module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-box"
  }, [_c('SmartForm', {
    attrs: {
      "inline": "inline",
      "formList": _vm.filterSlice,
      "columns": _vm.filterColumns,
      "values": _vm.filterValues,
      "buttonList": _vm.buttonList
    },
    on: {
      "changeFormValue": _vm.changeFormValue
    }
  }), _c('SeniorFilter', {
    attrs: {
      "dialogVisible": _vm.dialogVisible,
      "formList": _vm.filterList,
      "columns": _vm.filterColumns
    },
    on: {
      "getFormValues": _vm.getSeniorFormValues,
      "dialogVisiStatus": _vm.setDialogVisible
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c340b546","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilterBox/index.vue
// module id = 1799
// module chunks = 1